module.exports = __webpack_public_path__ + "media/images/favicons_staging/mstile-150x150-ad4c6fdbebe1349ba531d9f89c4c9c7e.png";